import $ from 'jquery';
import { fadeSlideIn, fadeSlideOut } from '../utils/animate';
import { clearInputValue, getAssociatedInputs, getInputValue, isRadio } from '../utils/input';
import { matchesCriteria } from '../utils/criteria';
const ELEMENT_SELECTOR = '.js__disable-target-on-value';
export class DisableTargetOnValue {
    static isInitialized = false;
    static init($root = $('body')) {
        if (!this.isInitialized) {
            this.bindGlobalChangeEvent();
        }
        $root.find(ELEMENT_SELECTOR).each((index, element) => this.handleValueChange($(element), 0));
    }
    static bindGlobalChangeEvent() {
        $(document).on('change', ELEMENT_SELECTOR, event => {
            let $target = $(event.target);
            if (isRadio($target)) {
                $target = getAssociatedInputs($target).filter(ELEMENT_SELECTOR);
            }
            $target.each((index, element) => this.handleValueChange($(element)));
        });
    }
    static handleValueChange($element, duration = 300) {
        if ($element.hasClass('ui dropdown')) {
            $element = $element.find('select');
        }
        const value = getInputValue($element);
        const { target, criteriaValue, clearDisabled, hideDisabled, inverseCriteria } = $element.data();
        const $targets = $(target);
        const disable = matchesCriteria(criteriaValue, value, inverseCriteria);
        $targets.each((index, element) => {
            const $target = $(element);
            const $parent = $target.closest('.field');
            if (disable && hideDisabled) {
                fadeSlideOut($parent, duration);
            }
            else {
                fadeSlideIn($parent, duration);
            }
            $target.prop('disabled', disable).toggleClass('disabled', disable);
            if (clearDisabled && disable) {
                clearInputValue($target);
            }
        });
    }
}
